import { Skeleton } from "@/components/ui/skeleton";

interface PageSkeletonProps {
  variant?: 'site' | 'dashboard' | 'list' | 'calendar' | 'settings';
}

export const PageSkeleton = ({ variant = 'site' }: PageSkeletonProps) => {
  if (variant === 'dashboard') {
    return (
      <div className="site-page-container space-y-xl">
        <div className="space-y-lg">
          <Skeleton className="h-8 w-64" />
          <Skeleton className="h-4 w-96" />
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-lg">
          <Skeleton className="h-32" />
          <Skeleton className="h-32" />
          <Skeleton className="h-32" />
        </div>
        
        <div className="space-y-lg">
          <Skeleton className="h-64" />
          <Skeleton className="h-64" />
        </div>
      </div>
    );
  }

  if (variant === 'list') {
    return (
      <div className="space-y-lg">
        <Skeleton className="h-8 w-48" />
        {[...Array(5)].map((_, i) => (
          <Skeleton key={i} className="h-24 w-full" />
        ))}
      </div>
    );
  }

  if (variant === 'calendar') {
    return (
      <div className="space-y-xl">
        <div className="flex items-center justify-between">
          <Skeleton className="h-10 w-48" />
          <div className="flex gap-sm">
            <Skeleton className="h-10 w-10" />
            <Skeleton className="h-10 w-10" />
          </div>
        </div>
        <div className="grid grid-cols-7 gap-sm">
          {[...Array(35)].map((_, i) => (
            <Skeleton key={i} className="h-24 w-full" />
          ))}
        </div>
      </div>
    );
  }

  if (variant === 'settings') {
    return (
      <div className="space-y-xl">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-lg">
          <Skeleton className="h-12 w-full" />
          <Skeleton className="h-12 w-full" />
        </div>
        <div className="space-y-lg">
          <Skeleton className="h-64 w-full" />
          <Skeleton className="h-64 w-full" />
        </div>
      </div>
    );
  }

  // Default 'site' variant
  return (
    <div className="space-y-lg">
      <Skeleton className="h-10 w-full max-w-md" />
      <div className="grid grid-cols-1 md:grid-cols-3 gap-lg">
        {[...Array(3)].map((_, i) => (
          <Skeleton key={i} className="h-32" />
        ))}
      </div>
      <Skeleton className="h-[400px] w-full" />
    </div>
  );
};
